import React, { Component } from 'react'
import { Box, Grommet, ResponsiveContext, Grid } from 'grommet'
import Header from './containers/Header'
import Main from './containers/Main'
import { theme } from './branding'
import { Authenticator } from '@aws-amplify/ui-react'
import { Amplify } from 'aws-amplify'
import config from './auth_config'
import '@aws-amplify/ui-react/styles.css'
import './App.css'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.userPoolWebClientId,
      identityPoolId: config.cognito.identityPoolId,
      loginWith: {
        email: true
      }
    }
  },
  API: {
    REST: {
      FetchBugfixList: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      CreateBugfixList: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      FetchRepos: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      FetchResources: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      GetResource: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    }
  }
})

const isProd = import.meta.env.MODE === 'production'
export class App extends Component {
  render () {
    return (
      <Grommet theme={theme} full>
        <ResponsiveContext.Consumer>
          {size => (
            <Grid
              rows={['xxsmall', 'small']}
              columns={['medium']}
              gap='small'
              areas={[
                { name: 'header', start: [0, 0], end: [1, 0] },
                { name: 'main', start: [0, 1], end: [1, 1] }
              ]}
            >
              <Box gridArea='header'>
                <Header isProd={isProd} />
              </Box>
              <Box gridArea='main' align='center'>
                <Box width='75%'>
                  <Main />
                </Box>
              </Box>
            </Grid>)
          }
        </ResponsiveContext.Consumer>
      </Grommet>
    )
  }
}

// Wrap with Authenticator in production
const AppWithAuth = () => (
  <Authenticator hideSignUp>
    {({ signOut, user }) => (
      <App />
    )}
  </Authenticator>
)

// export default isProd ? AppWithAuth : App
export default AppWithAuth
